import React, { useEffect } from 'react'
import { View } from './View'
import { useCompanyStats } from '../../../../../services/api/stats'
import { CompanyStatsData } from '../../../../../services/api/stats'
import { AsyncStates } from '../../../../../components'

type Props = {
  companyId: string
}

export const Container: React.FunctionComponent<Props> = ({ companyId }) => {
  const [getCompanyStats, { isLoading, response, error }] = useCompanyStats(
    companyId
  )

  useEffect(() => {
    getCompanyStats()
  }, [getCompanyStats])

  return (
    <AsyncStates<CompanyStatsData>
      isLoading={isLoading}
      error={error}
      errorMessage="Не удалось загрузить дополнительные данные по компании"
      reload={() => getCompanyStats()}
      response={response}
      renderData={(companyStats) => (
        <View
          companyId={companyStats.id}
          employeesCount={companyStats.employeesCount}
          ordersCount={companyStats.ordersCount}
          transactionsCount={companyStats.transactionsCount}
        />
      )}
    />
  )
}
